import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Cookies from "universal-cookie";

function CreaServiciosModalidad() {
  const cookies = new Cookies();
  const [postFechaCorte, setPostFechaCorte] = useState([]);
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  const [archivos, setArchivos] = useState(null);
  const subirArchivos = (e) => {
    setArchivos(e);
  };
  const insertarArchivos = async () => {
    const f = new FormData();
    for (let index = 0; index < archivos.length; index++) {
      f.append("files", archivos[index]);
    }
    await axios
      .post(
        "https://suadesarrollo.azurewebsites.net/api/CargueMasivosServicioModalidad?InstitucionId=" +
          cookies.get("institucionid"),
        f,
      )

      .then((response) => {
        console.log(response.data);
        alert("Cargue con exito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div>
      <button
        variant="contained"
        className="btn btn-primary"
        color="primary"
        onClick={handleOpenModalTest}
      >
        {" "}
        Adjuntar Documento
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Declaracion"
      >
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    Sube el documento
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table
                      class="table table-bordered"
                      id="dataTable"
                      width="100%"
                      cellspacing="0"
                    >
                      <td>
                        {" "}
                        <input
                          type="file"
                          name="files"
                          accept=".csv"
                          multiple
                          onChange={(e) => subirArchivos(e.target.files)}
                        />
                      </td>

                      <td>
                        {" "}
                        <input
                          type="number"
                          className="form-control form-control-user"
                          placeholder="Año de corte ejemplo: 2024"
                          onChange={(e) => setPostFechaCorte(e.target.value)}
                        />{" "}
                      </td>
                    </table>
                    <hr />
                    <button
                      className="btn btn-primary"
                      onClick={() => insertarArchivos()}
                    >
                      insertar archivos
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}
export default CreaServiciosModalidad;
